<template xmlns="http://www.w3.org/1999/html">
  <div class="container-fluid">
    <EntityListDisplay
        :items="users"
        :columns="userColumns"
        :hasActions="true"
    >
      <template #title>
        Lista de Usuarios
      </template>
      <template #new>
        <button class="btn btn-success btn-new-user d-flex align-items-center gap-2" @click="showNewUserModal = true">
          <i class="material-icons">person_add</i>
          <span>Nuevo Usuario</span>
        </button>
      </template>
      <template #actions="{ item }">
        <div class="btn-group pt-3" role="group">
          <button class="btn btn-info p-1 ms-1 shadow-3d" @click="viewUser(item)" title="Ver detalles del usuario">
            <i class="material-icons">visibility</i>
          </button>
          <button class="btn btn-warning p-1 ms-1 shadow-3d" @click="editUser(item)" title="Editar usuario">
            <i class="material-icons">edit</i>
          </button>
          <button class="btn btn-success p-1 ms-1 shadow-3d" @click="openBranchModal(item)" title="Establecer sucursal">
            <i class="material-icons">store</i>
          </button>
          <button v-if="canDeleteUser" class="btn btn-danger p-1 ms-1 shadow-3d" @click="deleteUser(item)" title="Eliminar usuario">
            <i class="material-icons">delete</i>
          </button>
        </div>
      </template>
      <template #card="{ item }">
        <div class="user-card-header">
          <div class="avatar-3d">
            <i class="material-icons">person</i>
          </div>
          <div class="user-card-title">
            <span class="user-name">{{ item.firstName }} {{ item.lastName }}</span>
            <span class="user-group">{{ item.groups ? item.groups.name : 'Sin rol' }}</span>
          </div>
        </div>
        <div class="user-card-body">
          <div class="user-info"><i class="material-icons">email</i> {{ item.email }}</div>
          <div class="user-info"><i class="material-icons">phone</i> {{ item.phone }}</div>
          <div class="user-info"><i class="material-icons">store</i> {{ item.branch ? item.branch.name : 'Sin sucursal' }}</div>
        </div>
      </template>
    </EntityListDisplay>
    <!-- Modal de nuevo usuario -->
    <div v-if="showNewUserModal" class="modal show">
      <div class="modal-content modal-professional">
        <div class="modal-header">
          <h4 class="modal-title">
            <i class="material-icons">person_add</i>
            Crear Nuevo Usuario
          </h4>
          <span class="modal-close" @click="showNewUserModal=false">
            <i class="material-icons">close</i>
          </span>
        </div>
        <form @submit.prevent="createUser" class="modal-form">
          <div class="form-row">
            <div class="form-group">
              <label class="form-label">
                <i class="material-icons">person</i>
                Nombre *
              </label>
              <input 
                v-model="newUser.firstName" 
                class="form-control form-control-modern" 
                placeholder="Ingrese el nombre"
                required
                @blur="validateField('firstName')"
              />
              <div v-if="errors.firstName" class="error-message">
                <i class="material-icons">error</i>
                {{ errors.firstName }}
              </div>
            </div>
            <div class="form-group">
              <label class="form-label">
                <i class="material-icons">person</i>
                Apellidos *
              </label>
              <input 
                v-model="newUser.lastName" 
                class="form-control form-control-modern" 
                placeholder="Ingrese los apellidos"
                required
                @blur="validateField('lastName')"
              />
              <div v-if="errors.lastName" class="error-message">
                <i class="material-icons">error</i>
                {{ errors.lastName }}
              </div>
            </div>
          </div>
          
          <div class="form-group">
            <label class="form-label">
              <i class="material-icons">email</i>
              Correo Electrónico *
            </label>
            <input 
              v-model="newUser.email" 
              type="email"
              class="form-control form-control-modern" 
              placeholder="usuario@ejemplo.com"
              required
              autocomplete="new-email"
              @blur="validateField('email')"
            />
            <div v-if="errors.email" class="error-message">
              <i class="material-icons">error</i>
              {{ errors.email }}
            </div>
          </div>
          
          <div class="form-group">
            <label class="form-label">
              <i class="material-icons">phone</i>
              Teléfono *
            </label>
            <MazPhoneNumberInput
                v-model="newUser.phone"
                v-model:country-code="newUser.codePhone"
                show-code-on-list
                :preferred-countries="['MX', 'US', 'CU']"
                :only-countries="['MX', 'US', 'CU']"
                no-radius
                noBorder="false"
                class="phone-input-modern"
                :translations="{
                      countrySelector: {
                        placeholder: 'Código de país',
                        error: 'Seleccione un país',
                        searchPlaceholder: 'Buscar un país',
                      },
                      phoneInput: {
                        placeholder: 'Número de teléfono',
                        example: 'Ejemplo:',
                      },
                    }"
                @blur="validateField('phone')"
            />
            <div v-if="errors.phone" class="error-message">
              <i class="material-icons">error</i>
              {{ errors.phone }}
            </div>
          </div>
          
          <div class="form-group">
            <label class="form-label">
              <i class="material-icons">lock</i>
              Contraseña *
            </label>
            <div class="password-input-container">
              <input 
                v-model="newUser.password" 
                :type="showPassword ? 'text' : 'password'" 
                class="form-control form-control-modern" 
                placeholder="Mínimo 8 caracteres"
                required
                @blur="validateField('password')"
              />
              <button 
                type="button" 
                class="password-toggle"
                @click="showPassword = !showPassword"
              >
                <i class="material-icons">{{ showPassword ? 'visibility_off' : 'visibility' }}</i>
              </button>
            </div>
            <div v-if="errors.password" class="error-message">
              <i class="material-icons">error</i>
              {{ errors.password }}
            </div>
          </div>
          
          <div class="form-group">
            <label class="form-label">
              <i class="material-icons">group</i>
              Rol/Grupo
            </label>
            <select v-model="newUser.group_id" class="form-control form-control-modern">
              <option value="">Seleccione un rol (opcional)</option>
              <option v-for="group in groups" :key="group.id" :value="group.id">{{ group.name }}</option>
            </select>
          </div>

          <div class="form-group">
            <label class="form-label">
              <i class="material-icons">draw</i>
              Firma (opcional)
            </label>
            <input
              type="file"
              accept="image/*"
              class="form-control form-control-modern"
              @change="onNewUserSignatureChange"
            >
            <small class="text-muted">Imagen de la firma del usuario para incluir en contratos PDF.</small>
          </div>
          
          <div class="modal-actions">
            <button type="button" class="btn btn-secondary" @click="showNewUserModal=false">
              <i class="material-icons">cancel</i>
              Cancelar
            </button>
            <button type="submit" class="btn btn-primary" :disabled="!isFormValid">
              <i class="material-icons">save</i>
              Crear Usuario
            </button>
          </div>
        </form>
      </div>
    </div>
    <!-- Modal de detalle -->
    <DetailModal
      :show="showUserModal"
      title="Detalles de Usuario"
      subtitle="Información completa del usuario"
      icon="person"
      :data="selectedUser"
      size="medium"
      :show-edit-button="true"
      :hidden-fields="['id', 'password', 'createdAt', 'updatedAt']"
      :field-labels="{
        firstName: 'Nombre',
        lastName: 'Apellidos',
        email: 'Correo Electrónico',
        phone: 'Teléfono',
        groups: 'Grupo/Rol',
        branch: 'Sucursal',
        isActive: 'Estado',
        lastLogin: 'Último Acceso'
      }"
      :field-icons="{
        firstName: 'person',
        lastName: 'person',
        email: 'email',
        phone: 'phone',
        groups: 'group',
        branch: 'store',
        isActive: 'check_circle',
        lastLogin: 'schedule'
      }"
      @close="showUserModal = false"
      @edit="editUser(selectedUser)"
    />
    <!-- Modal de edición -->
    <div v-if="showEditModal" class="modal show">
      <div class="modal-content modal-professional">
        <div class="modal-header">
          <h4 class="modal-title">
            <i class="material-icons">edit</i>
            Editar Usuario
          </h4>
          <span class="modal-close" @click="showEditModal=false">
            <i class="material-icons">close</i>
          </span>
        </div>
        <form @submit.prevent="saveEdit" class="modal-form">
          <div class="form-row">
            <div class="form-group">
              <label class="form-label">
                <i class="material-icons">person</i>
                Nombre *
              </label>
              <input 
                v-model="selectedUser.firstName" 
                class="form-control form-control-modern" 
                placeholder="Ingrese el nombre"
                required
              />
            </div>
            <div class="form-group">
              <label class="form-label">
                <i class="material-icons">person</i>
                Apellidos *
              </label>
              <input 
                v-model="selectedUser.lastName" 
                class="form-control form-control-modern" 
                placeholder="Ingrese los apellidos"
                required
              />
            </div>
          </div>
          
          <div class="form-group">
            <label class="form-label">
              <i class="material-icons">email</i>
              Correo Electrónico *
            </label>
            <input 
              v-model="selectedUser.email" 
              type="email"
              class="form-control form-control-modern" 
              placeholder="usuario@ejemplo.com"
              required
              autocomplete="new-email"
            />
          </div>
          
          <div class="form-group">
            <label class="form-label">
              <i class="material-icons">phone</i>
              Teléfono *
            </label>
            <MazPhoneNumberInput
                v-model="selectedUser.phone"
                v-model:country-code="selectedUser.codePhone"
                show-code-on-list
                :preferred-countries="['MX', 'US', 'CU']"
                :only-countries="['MX', 'US', 'CU']"
                no-radius
                noBorder="false"
                class="phone-input-modern"
                :translations="{
                      countrySelector: {
                        placeholder: 'Código de país',
                        error: 'Seleccione un país',
                        searchPlaceholder: 'Buscar un país',
                      },
                      phoneInput: {
                        placeholder: 'Número de teléfono',
                        example: 'Ejemplo:',
                      },
                    }"
            />
          </div>
          
          <div class="form-group">
            <label class="form-label">
              <i class="material-icons">group</i>
              Rol/Grupo
            </label>
            <select v-model="selectedUser.groups.id" class="form-control form-control-modern">
              <option value="">Sin grupo</option>
              <option v-for="group in groups" :key="group.id" :value="group.id">{{ group.name }}</option>
            </select>
          </div>

          <div class="form-group">
            <label class="form-label">
              <i class="material-icons">draw</i>
              Firma (opcional)
            </label>
            <input
              type="file"
              accept="image/*"
              class="form-control form-control-modern"
              @change="onEditUserSignatureChange"
            >
            <small class="text-muted">Imagen de la firma para firmar contratos con este usuario. Si sube una nueva, reemplaza la anterior.</small>
          </div>
          
          <div class="modal-actions">
            <button type="button" class="btn btn-secondary" @click="showEditModal=false">
              <i class="material-icons">cancel</i>
              Cancelar
            </button>
            <button type="submit" class="btn btn-primary">
              <i class="material-icons">save</i>
              Guardar Cambios
            </button>
          </div>
        </form>
      </div>
    </div>
    <!-- Modal para establecer sucursal -->
    <div v-if="showBranchModal" class="modal show">
      <div class="modal-content modal-professional">
        <div class="modal-header">
          <h4 class="modal-title">
            <i class="material-icons">store</i>
            Establecer Sucursal
          </h4>
          <span class="modal-close" @click="closeBranchModal">
            <i class="material-icons">close</i>
          </span>
        </div>
        <form @submit.prevent="saveUserBranch" class="modal-form">
          <div class="form-group">
            <label class="form-label">
              <i class="material-icons">person</i>
              Usuario
            </label>
            <input
              :value="`${selectedUser.firstName} ${selectedUser.lastName}`"
              class="form-control form-control-modern"
              disabled
            />
          </div>

          <div class="form-group">
            <label class="form-label">
              <i class="material-icons">store</i>
              Sucursal *
            </label>
            <select v-model="branchSelection" class="form-control form-control-modern" required>
              <option value="">Seleccione una sucursal</option>
              <option v-for="branch in branches" :key="branch.id" :value="branch.id">{{ branch.name }}</option>
            </select>
          </div>

          <div class="modal-actions">
            <button type="button" class="btn btn-secondary" @click="closeBranchModal">
              <i class="material-icons">cancel</i>
              Cancelar
            </button>
            <button type="submit" class="btn btn-primary" :disabled="!branchSelection">
              <i class="material-icons">save</i>
              Guardar Sucursal
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex';
import EntityListDisplay from "@/components/EntityListDisplay.vue";
import DetailModal from "@/components/DetailModal.vue";
import MaterialButton from "@/components/MaterialButton.vue";
import Swal from "sweetalert2";
import {showSuccess, showError} from "@/actions";
import MazPhoneNumberInput from "maz-ui/components/MazPhoneNumberInput";
import { Permissions } from '@/utils/permissions';

export default {
  name: "List_Users",
  components: {MaterialButton, EntityListDisplay, DetailModal, MazPhoneNumberInput},
  data() {
    return {
      userColumns: [
        {key: "firstName", label: "Nombre"},
        {key: "lastName", label: "Apellidos"},
        {key: "email", label: "Correo"},
        {key: "phone", label: "Teléfono"},
        {key: "groups", label: "Grupo", formatter: (value, item) => item.groups ? item.groups.name : "Sin grupo"},
        {key: "branch", label: "Sucursal", formatter: (value, item) => item.branch ? item.branch.name : "Sin sucursal"}
      ],
      users: [],
      selectedUser: {
        id: "",
        firstName: "",
        lastName: "",
        codePhone: "",
        email: "",
        phone: "",
        groups: {
          id: "",
          name: ""
        },
        branch: null
      },
      showUserModal: false,
      showEditModal: false,
      showNewUserModal: false,
      showBranchModal: false,
      showPassword: false,
      branchSelection: "",
      newUser: {
        firstName: "",
        lastName: "",
        codePhone: "",
        email: "",
        phone: "",
        password: "",
        group_id: "",
        firmaFile: null
      },
      editSignatureFile: null,
      groups: [],
      branches: [],
      errors: {}
    }
  },
  computed: {
    ...mapGetters(['canDelete', 'hasPermission', 'isAdmin']),
    canViewUser() {
      // Administrador tiene acceso total
      if (this.isAdmin) {
        return true;
      }
      return this.hasPermission(Permissions.SECURITY_USER_CRUD);
    },
    canEditUser() {
      // Administrador tiene acceso total
      if (this.isAdmin) {
        return true;
      }
      return this.hasPermission(Permissions.SECURITY_USER_CRUD);
    },
    canCreateUser() {
      // Administrador tiene acceso total
      if (this.isAdmin) {
        return true;
      }
      return this.hasPermission(Permissions.SECURITY_USER_CRUD);
    },
    canDeleteUser() {
      // Administrador tiene acceso total
      if (this.isAdmin) {
        return true;
      }
      return this.canDelete('security.user') || this.hasPermission(Permissions.SECURITY_USER_DELETE);
    },
    isFormValid() {
      return this.newUser.firstName && 
             this.newUser.lastName && 
             this.newUser.email && 
             this.newUser.phone && 
             this.newUser.password &&
             !this.errors.firstName &&
             !this.errors.lastName &&
             !this.errors.email &&
             !this.errors.phone &&
             !this.errors.password;
    }
  },
  methods: {
    async fetchUsers() {
      const {users, groups, allBranches} = await import("@/actions");
      const resUsers = await users();
      this.users = resUsers.data.data.users || [];
      const resGroups = await groups();
      this.groups = resGroups.data.data.groups || [];
      const resBranches = await allBranches();
      this.branches = resBranches.data.data.allBranches || [];
    },
    onNewUserSignatureChange(e) {
      const file = e.target.files && e.target.files[0];
      this.newUser.firmaFile = file || null;
    },
    onEditUserSignatureChange(e) {
      const file = e.target.files && e.target.files[0];
      this.editSignatureFile = file || null;
    },
    editUser(user) {
      this.selectedUser = {...user};
      if (!this.selectedUser.groups) {
        this.selectedUser.groups = {id: ""};
      }
      this.editSignatureFile = null;
      this.showEditModal = true;
    },
    openBranchModal(user) {
      this.selectedUser = {
        ...user,
        branch: user.branch || null
      };
      this.branchSelection = user.branch ? user.branch.id : "";
      this.showBranchModal = true;
    },
    closeBranchModal() {
      this.showBranchModal = false;
      this.branchSelection = "";
    },
    async saveUserBranch() {
      if (!this.branchSelection) {
        showError("Seleccione una sucursal para el usuario", "Sucursal requerida");
        return;
      }

      const {setUserBranch} = await import("@/actions");
      try {
        const res = await setUserBranch(this.selectedUser.id, this.branchSelection);
        const result = res.data.data.updateUser;
        if (result && result.user) {
          await this.fetchUsers();
          this.closeBranchModal();
          showSuccess("Sucursal actualizada correctamente", "Usuario actualizado", {timer: 1800});
        } else {
          showError(result?.error || "Error al actualizar la sucursal", "Error al actualizar");
        }
      } catch (e) {
        showError(e.message || "Error de conexión", "Error al actualizar");
      }
    },
    async saveEdit() {
      const {updateUser, uploadUserSignature} = await import("@/actions");
      try {
        const res = await updateUser({
          id: this.selectedUser.id,
          email: this.selectedUser.email,
          phone: this.selectedUser.phone,
          codePhone: this.selectedUser.codePhone,
          groupId: this.selectedUser.groups.id,
          firstName: this.selectedUser.firstName,
          lastName: this.selectedUser.lastName
        });
        if (res.data.data.updateUser && res.data.data.updateUser.user) {
          if (this.editSignatureFile) {
            try {
              const up = await uploadUserSignature(this.selectedUser.id, this.editSignatureFile);
              const result = up?.data?.data?.uploadUserSignature;
              if (result && result.success !== false) {
                showSuccess(`Usuario y firma actualizados correctamente`, `Guardado`, {timer: 1800});
              } else {
                showSuccess(`Usuario actualizado. Firma: ${result?.error || 'Error al subir'}`, `Usuario actualizado`, {timer: 2500});
              }
            } catch (err) {
              showSuccess(`Usuario actualizado. No se pudo subir la firma.`, `Usuario actualizado`, {timer: 2500});
            }
            this.editSignatureFile = null;
          } else {
            showSuccess(`Usuario actualizado correctamente`, `Usuario actualizado`, {timer: 1800});
          }
          await this.fetchUsers();
          this.showEditModal = false;
        } else {
          showError(res.data.data.updateUser.error || "Error al actualizar usuario", "Error al actualizar");
        }
      } catch (e) {
        showError(e.message || "Error de conexión", "Error al actualizar");
      }
    },
    viewUser(user) {
      this.selectedUser = user;
      this.showUserModal = true;
    },
    async deleteUser(user) {
      const result = await Swal.fire({
        title: `¿Eliminar usuario '${user.firstName} ${user.lastName}'?`,
        text: "Esta acción no se puede deshacer.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: "Sí, eliminar",
        cancelButtonText: "Cancelar"
      });
      if (result.isConfirmed) {
        const {deleteUser} = await import("@/actions");
        try {
          const res = await deleteUser(user.id);
          if (res.data.data.deleteUser && res.data.data.deleteUser.ok) {
            await this.fetchUsers()
            showSuccess(`El usuario ha sido eliminado correctamente.`, `Usuario eliminado`, {timer: 1800});
          } else {
            showError(res.data.data.deleteUser.error || "No se pudo eliminar el usuario.", "Error al eliminar");
          }
        } catch (e) {
          showError("Error de conexión.", "Error al eliminar");
        }
      }
    },
    validateField(field) {
      this.errors = { ...this.errors };
      
      switch (field) {
        case 'firstName':
          if (!this.newUser.firstName || this.newUser.firstName.trim().length < 2) {
            this.errors.firstName = 'El nombre debe tener al menos 2 caracteres';
          } else {
            delete this.errors.firstName;
          }
          break;
          
        case 'lastName':
          if (!this.newUser.lastName || this.newUser.lastName.trim().length < 2) {
            this.errors.lastName = 'Los apellidos deben tener al menos 2 caracteres';
          } else {
            delete this.errors.lastName;
          }
          break;
          
        case 'email':
          const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
          if (!this.newUser.email) {
            this.errors.email = 'El correo electrónico es requerido';
          } else if (!emailRegex.test(this.newUser.email)) {
            this.errors.email = 'Ingrese un correo electrónico válido';
          } else {
            delete this.errors.email;
          }
          break;
          
        case 'phone':
          if (!this.newUser.phone || this.newUser.phone.trim().length < 10) {
            this.errors.phone = 'El teléfono debe tener al menos 10 dígitos';
          } else {
            delete this.errors.phone;
          }
          break;
          
        case 'password':
          if (!this.newUser.password || this.newUser.password.length < 8) {
            this.errors.password = 'La contraseña debe tener al menos 8 caracteres';
          } else {
            delete this.errors.password;
          }
          break;
      }
    },
    
    async createUser() {
      // Validar todos los campos antes de enviar
      this.validateField('firstName');
      this.validateField('lastName');
      this.validateField('email');
      this.validateField('phone');
      this.validateField('password');
      
      if (Object.keys(this.errors).length > 0) {
        showError("Por favor corrija los errores en el formulario", "Error de validación");
        return;
      }
      
      const {createUser} = await import("@/actions");
      try {
        // Mapear group_id a groupId para la mutación GraphQL (no enviar firmaFile)
        const userData = {
          ...this.newUser,
          groupId: this.newUser.group_id || null
        };
        delete userData.group_id;
        delete userData.firmaFile;

        const res = await createUser(userData);
        if (res.data.data.createUser && res.data.data.createUser.user) {
          const createdUser = res.data.data.createUser.user;
          if (this.newUser.firmaFile) {
            try {
              const {uploadUserSignature} = await import("@/actions");
              await uploadUserSignature(createdUser.id, this.newUser.firmaFile);
            } catch (err) {
              console.warn("Usuario creado; no se pudo subir la firma:", err);
            }
          }
          this.fetchUsers();
          this.showNewUserModal = false;
          this.newUser = {firstName: "", lastName: "", codePhone: "", email: "", phone: "", password: "", group_id: "", firmaFile: null};
          this.errors = {};
          this.showPassword = false;
          showSuccess(`Usuario creado correctamente`, `Usuario creado`, {timer: 1800});
        } else {
          showError(res.data.data.createUser.error || "Error al crear usuario", "Error al crear");
        }
      } catch (e) {
        showError("Error de conexión", "Error al crear");
      }
    }
  },
  mounted() {
    this.fetchUsers();
  }
}
</script>

<style scoped>
.btn-new-user {
  font-size: 1.1rem;
  padding: 0.5rem 1.2rem;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(2, 33, 38, 0.08);
  background: linear-gradient(90deg, #3A9F1D 0%, #5fe939 100%);
  color: #fff;
  font-weight: bold;
  transition: background 0.2s;
}

.btn-new-user:hover {
  background: linear-gradient(90deg, #5fe939 0%, #3A9F1D 100%);
  color: #fff;
}

.modal {
  /* Spinner global */

  .site-spinner {
    width: 60px;
    height: 60px;
    border: 7px solid #e0e0e0;
    border-top: 7px solid #3A9F1D;
    border-right: 7px solid #5fe939;
    border-radius: 50%;
    animation: spin 1s linear infinite;
  }

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 9999;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal-icon {
  position: absolute;
  top: 10px;
  right: 10px;
  cursor: pointer;
}

.modal-content {
  background-color: white;
  padding: 20px;
  border-radius: 15px;
  width: 50%;
}

/* Estilos profesionales para formularios */
.modal-professional {
  max-width: 600px;
  width: 90%;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);
  border: none;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 20px;
  border-bottom: 2px solid #f0f0f0;
  margin-bottom: 25px;
}

.modal-title {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 1.4rem;
  font-weight: 600;
  color: #2c3e50;
  margin: 0;
}

.modal-title .material-icons {
  color: #3A9F1D;
  font-size: 1.6rem;
}

.modal-close {
  cursor: pointer;
  padding: 8px;
  border-radius: 50%;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-close:hover {
  background-color: #f8f9fa;
  color: #dc3545;
}

.modal-close .material-icons {
  font-size: 1.4rem;
}

.modal-form {
  padding: 0;
}

.form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
  margin-bottom: 20px;
}

.form-group {
  margin-bottom: 20px;
}

.form-label {
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 600;
  color: #2c3e50;
  margin-bottom: 8px;
  font-size: 0.95rem;
}

.form-label .material-icons {
  font-size: 1.1rem;
  color: #3A9F1D;
}

.form-control-modern {
  width: 100%;
  padding: 12px 16px;
  border: 2px solid #e9ecef;
  border-radius: 8px;
  font-size: 1rem;
  transition: all 0.3s ease;
  background-color: #fff;
}

.form-control-modern:focus {
  outline: none;
  border-color: #3A9F1D;
  box-shadow: 0 0 0 3px rgba(58, 159, 29, 0.1);
}

.form-control-modern::placeholder {
  color: #adb5bd;
  font-style: italic;
}

.password-input-container {
  position: relative;
  display: flex;
  align-items: center;
}

.password-toggle {
  position: absolute;
  right: 12px;
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
  border-radius: 4px;
  color: #6c757d;
  transition: color 0.2s ease;
}

.password-toggle:hover {
  color: #3A9F1D;
}

.password-toggle .material-icons {
  font-size: 1.2rem;
}

.phone-input-modern {
  width: 100%;
}

.error-message {
  display: flex;
  align-items: center;
  gap: 6px;
  color: #dc3545;
  font-size: 0.85rem;
  margin-top: 6px;
  font-weight: 500;
}

.error-message .material-icons {
  font-size: 1rem;
}

.modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding-top: 20px;
  border-top: 2px solid #f0f0f0;
  margin-top: 25px;
}

.btn {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 24px;
  border: none;
  border-radius: 8px;
  font-weight: 600;
  font-size: 0.95rem;
  cursor: pointer;
  transition: all 0.3s ease;
  text-decoration: none;
}

.btn-primary {
  background: linear-gradient(135deg, #3A9F1D 0%, #5fe939 100%);
  color: white;
  box-shadow: 0 4px 12px rgba(58, 159, 29, 0.3);
}

.btn-primary:hover:not(:disabled) {
  background: linear-gradient(135deg, #2d7a16 0%, #4dd32a 100%);
  box-shadow: 0 6px 16px rgba(58, 159, 29, 0.4);
  transform: translateY(-1px);
}

.btn-primary:disabled {
  background: #6c757d;
  cursor: not-allowed;
  box-shadow: none;
  transform: none;
}

.btn-secondary {
  background: #6c757d;
  color: white;
  box-shadow: 0 4px 12px rgba(108, 117, 125, 0.3);
}

.btn-secondary:hover {
  background: #5a6268;
  box-shadow: 0 6px 16px rgba(108, 117, 125, 0.4);
  transform: translateY(-1px);
}

.btn .material-icons {
  font-size: 1.1rem;
}

@media (max-width: 768px) {
  .form-row {
    grid-template-columns: 1fr;
    gap: 0;
  }
  
  .modal-professional {
    width: 95%;
    margin: 10px;
  }
  
  .modal-actions {
    flex-direction: column;
  }
  
  .btn {
    justify-content: center;
  }
}

.modal {
  opacity: 0;
  transition: opacity 0.3s ease-in-out;
}

.modal.show {
  opacity: 1;
}

@media (max-width: 550px) {
  .modal-content {
    width: 90%;
    margin-top: 20%;
  }
}

.user-card .card-actions {
  margin-top: 1rem;
  display: flex;
  gap: 0.5rem;
}

.user-card-header {
  display: flex;
  align-items: center;
  margin-bottom: 1.1rem;
}

.avatar-3d {
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background: linear-gradient(135deg, #3A9F1D 0%, #5fe939 100%);
  box-shadow: 0 4px 16px #3A9F1D44, 0 1px 0 #5fe939 inset;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 2.2rem;
  margin-right: 1.1rem;
}

.user-card-title {
  display: flex;
  flex-direction: column;
}

.user-name {
  font-weight: bold;
  font-size: 1.18rem;
  color: #2a4d1b;
  text-shadow: 0 1px 0 #fff;
}

.user-group {
  font-size: 0.98rem;
  color: #5fe939;
  font-weight: 500;
  margin-top: 2px;
}

.user-card-body {
  margin-bottom: 1.1rem;
}

.user-info {
  display: flex;
  align-items: center;
  font-size: 1.04rem;
  color: #3A9F1D;
  margin-bottom: 0.4rem;
}

.user-info i {
  font-size: 1.1rem;
  margin-right: 0.5rem;
  color: #5fe939;
}

</style>
